(function () {
  if (window.__fellowAtcBridgeLoaded) return;
  window.__fellowAtcBridgeLoaded = true;

  var DEDUPE_WINDOW_MS = 2000;
  var CROSS_SIGNAL_DEDUPE_MS = 1200;
  var recentEvents = new Map();
  var lastTrackedAt = 0;

  function debugLog() {
    if (!window.__ATC_DEBUG__) return;
    try {
      console.log.apply(console, ["[atc-bridge]"].concat(Array.prototype.slice.call(arguments)));
    } catch (_e) {
      // no-op
    }
  }

  function now() {
    return Date.now();
  }

  function isProductTemplate() {
    var className = document.body && document.body.className;
    return typeof className === "string" && className.indexOf("template-product") !== -1;
  }

  function toAbsoluteUrl(maybeUrl) {
    if (!maybeUrl || typeof maybeUrl !== "string") return "";
    if (maybeUrl.indexOf("http://") === 0 || maybeUrl.indexOf("https://") === 0) {
      return maybeUrl;
    }
    if (maybeUrl.indexOf("//") === 0) {
      return window.location.protocol + maybeUrl;
    }
    if (maybeUrl.charAt(0) === "/") {
      return window.location.origin + maybeUrl;
    }
    return maybeUrl;
  }

  function centsToNumber(value) {
    var parsed = Number(value || 0);
    if (!Number.isFinite(parsed)) return 0;
    return parsed / 100;
  }

  function getCurrencyCode() {
    if (window.Shopify && window.Shopify.currency) {
      return window.Shopify.currency.active || window.Shopify.currency.currency || "USD";
    }
    return "USD";
  }

  function getVariantImageUrl(variant) {
    if (!variant || typeof variant !== "object") return "";

    var featuredImage = variant.featured_image || {};
    if (featuredImage && typeof featuredImage === "object") {
      if (typeof featuredImage.url === "string" && featuredImage.url) return featuredImage.url;
      if (typeof featuredImage.src === "string" && featuredImage.src) return featuredImage.src;
    }

    var featuredMedia = variant.featured_media || {};
    if (featuredMedia && typeof featuredMedia === "object") {
      var previewImage = featuredMedia.preview_image || {};
      if (previewImage && typeof previewImage === "object") {
        if (typeof previewImage.url === "string" && previewImage.url) return previewImage.url;
        if (typeof previewImage.src === "string" && previewImage.src) return previewImage.src;
      }
    }

    if (typeof variant.image === "string" && variant.image) return variant.image;
    return "";
  }

  function getVariantImageMapFromDom() {
    var map = new Map();
    var scripts = document.querySelectorAll("script[data-product-variants]");

    for (var i = 0; i < scripts.length; i += 1) {
      var script = scripts[i];
      var parsedVariants = [];

      try {
        parsedVariants = JSON.parse((script && script.textContent) || "[]");
      } catch (_error) {
        parsedVariants = [];
      }

      if (!Array.isArray(parsedVariants)) continue;

      for (var j = 0; j < parsedVariants.length; j += 1) {
        var variant = parsedVariants[j];
        if (!variant || typeof variant !== "object" || !variant.id) continue;
        var imageUrl = getVariantImageUrl(variant);
        if (!imageUrl) continue;
        map.set(String(variant.id), toAbsoluteUrl(imageUrl));
      }
    }

    return map;
  }

  function flattenItems(items) {
    var flattened = [];
    if (!Array.isArray(items)) return flattened;

    function walk(value) {
      if (Array.isArray(value)) {
        for (var i = 0; i < value.length; i += 1) {
          walk(value[i]);
        }
        return;
      }
      flattened.push(value);
    }

    walk(items);
    return flattened;
  }

  function normalizeItem(item, variantImageMap) {
    if (!item || typeof item !== "object") return null;

    var quantity = Number(item.quantity || 1);
    if (!Number.isFinite(quantity) || quantity < 1) quantity = 1;

    var variantId = item.variant_id || item.id || item.variantId || "";
    var productId = item.product_id || item.productId || "";
    var sku = item.sku || "";
    var productTitle = item.product_title || item.productTitle || item.name || item.title || "";
    var variantTitle = item.variant_title || item.variantTitle || "";
    var priceCents = Number(item.final_price || item.price || 0);
    if (!Number.isFinite(priceCents)) priceCents = 0;

    var imageUrl = "";
    if (item.featured_image && typeof item.featured_image === "object") {
      imageUrl = item.featured_image.url || "";
    } else if (typeof item.image === "string") {
      imageUrl = item.image;
    }
    if (!imageUrl && variantId && variantImageMap instanceof Map) {
      imageUrl = variantImageMap.get(String(variantId || "")) || "";
    }

    return {
      variantId: String(variantId || ""),
      productId: String(productId || ""),
      sku: String(sku || ""),
      title: String(productTitle || ""),
      variantTitle: String(variantTitle || ""),
      priceCents: priceCents,
      quantity: quantity,
      url: toAbsoluteUrl(item.url || ""),
      imageUrl: toAbsoluteUrl(imageUrl || ""),
      vendor: String(item.vendor || ""),
      productType: String(item.product_type || ""),
    };
  }

  function normalizeItems(items) {
    var flattenedItems = flattenItems(items);
    if (flattenedItems.length === 0) return [];

    var variantImageMap = getVariantImageMapFromDom();
    var normalized = [];
    for (var i = 0; i < flattenedItems.length; i += 1) {
      var n = normalizeItem(flattenedItems[i], variantImageMap);
      if (n) normalized.push(n);
    }
    return normalized;
  }

  function makeSignature(items) {
    var parts = [];
    for (var i = 0; i < items.length; i += 1) {
      var item = items[i];
      parts.push(item.variantId + ":" + item.quantity + ":" + item.priceCents);
    }
    parts.sort();
    return parts.join("|");
  }

  function isDuplicate(signature) {
    var timestamp = now();

    recentEvents.forEach(function (value, key) {
      if (timestamp - value > DEDUPE_WINDOW_MS) {
        recentEvents.delete(key);
      }
    });

    var lastSeen = recentEvents.get(signature);
    if (lastSeen && timestamp - lastSeen < DEDUPE_WINDOW_MS) {
      return true;
    }

    recentEvents.set(signature, timestamp);
    return false;
  }

  function pushGenericDataLayer(items) {
    var currency = getCurrencyCode();
    var eventValue = 0;
    var dataLayerItems = [];

    for (var i = 0; i < items.length; i += 1) {
      var item = items[i];
      var unitPrice = centsToNumber(item.priceCents);
      eventValue += unitPrice * item.quantity;
      dataLayerItems.push({
        item_id: item.sku || item.variantId,
        item_name: item.title,
        item_category: item.productType || "",
        item_variant: item.variantTitle || "",
        item_brand: item.vendor || "",
        quantity: item.quantity,
        price: unitPrice,
        item_id_shopify: item.productId || "",
      });
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: "add_to_cart",
      ecommerce: {
        currency: currency,
        value: Number(eventValue.toFixed(2)),
        items: dataLayerItems,
      },
    });
  }

  function fireDataLayer(items) {
    try {
      if (items.length > 1 && typeof window.gtmAtcBundle === "function") {
        var bundleItems = [];
        var bundleValue = 0;
        for (var i = 0; i < items.length; i += 1) {
          var item = items[i];
          bundleItems.push({
            sku: item.sku || item.variantId,
            name: item.title,
            price: item.priceCents,
            title: item.variantTitle,
            id: item.productId,
          });
          bundleValue += centsToNumber(item.priceCents) * item.quantity;
        }
        window.gtmAtcBundle(bundleItems, Number(bundleValue.toFixed(2)));
        return;
      }

      if (isProductTemplate() && typeof window.atcDL === "function") {
        window.atcDL();
        return;
      }

      pushGenericDataLayer(items);
    } catch (error) {
      debugLog("dataLayer tracking failed", error);
      pushGenericDataLayer(items);
    }
  }

  function queueKlaviyoTrack(items) {
    var learnq = window._learnq = window._learnq || [];
    var currency = getCurrencyCode();

    for (var i = 0; i < items.length; i += 1) {
      var item = items[i];
      var payload = {
        Name: item.title,
        Brand: item.vendor || "Fellow",
        Categories: item.productType ? [item.productType] : [],
        ProductID: item.productId || item.variantId,
        ImageURL: item.imageUrl || "",
        URL: item.url || window.location.href,
        Price: centsToNumber(item.priceCents).toFixed(2),
        CompareAtPrice: "",
        Currency: currency,
        $value: Number((centsToNumber(item.priceCents) * item.quantity).toFixed(2)),
      };

      learnq.push(["track", "Added to Cart", payload]);
    }
  }

  function fireKlaviyo(items) {
    try {
      queueKlaviyoTrack(items);
    } catch (error) {
      debugLog("Klaviyo tracking failed", error);
      queueKlaviyoTrack(items);
    }
  }

  function shouldUseLegacyDataLayerFallback() {
    return !window.__fellowCartAnalyticsLoaded;
  }

  function fireTracking(items, source) {
    var normalizedItems = normalizeItems(items);
    if (normalizedItems.length === 0) return;

    var timestamp = now();
    if (timestamp - lastTrackedAt < CROSS_SIGNAL_DEDUPE_MS) {
      debugLog("cross-signal deduped", source);
      return;
    }

    var signature = makeSignature(normalizedItems);
    if (isDuplicate(signature)) {
      debugLog("deduped", source, signature);
      return;
    }

    lastTrackedAt = timestamp;
    debugLog("tracking", source, normalizedItems);
    if (shouldUseLegacyDataLayerFallback()) {
      fireDataLayer(normalizedItems);
    } else {
      debugLog("skipping legacy dataLayer push", source);
    }
    fireKlaviyo(normalizedItems);
  }

  function getRequestInfo(input, init) {
    var method = "GET";
    var url = "";

    if (typeof input === "string") {
      url = input;
      if (init && init.method) method = String(init.method);
    } else if (input && typeof input === "object") {
      url = input.url || "";
      method = String((init && init.method) || input.method || "GET");
    }

    return {
      url: String(url || ""),
      method: method.toUpperCase(),
    };
  }

  function isCartAddRequest(input, init) {
    var requestInfo = getRequestInfo(input, init);
    if (requestInfo.method !== "POST") return false;
    return /\/cart\/add(\.js)?(\?|$)/.test(requestInfo.url);
  }

  function extractItemsFromResponseBody(body) {
    if (!body) return [];
    if (Array.isArray(body.items)) return body.items;
    if (body.item && typeof body.item === "object") return [body.item];
    if (body.id || body.variant_id || body.product_id) return [body];
    return [];
  }

  function attachCartItemsAddedListener() {
    document.addEventListener("cart:items-added", function (event) {
      var detail = event && event.detail ? event.detail : {};
      fireTracking(detail.items || [], "cart:items-added");
    });
  }

  function attachFetchListener() {
    if (typeof window.fetch !== "function") return;
    var originalFetch = window.fetch.bind(window);

    window.fetch = function () {
      var args = arguments;
      var input = args[0];
      var init = args[1];
      var shouldInspect = isCartAddRequest(input, init);

      return originalFetch.apply(window, args).then(function (response) {
        if (!shouldInspect || !response || !response.ok) return response;

        response
          .clone()
          .json()
          .then(function (body) {
            fireTracking(extractItemsFromResponseBody(body), "fetch:/cart/add");
          })
          .catch(function () {
            debugLog("Unable to parse /cart/add response body");
          });

        return response;
      });
    };
  }

  attachCartItemsAddedListener();
  attachFetchListener();
})();
